import React from 'react';
import { Play, Square, Image as ImageIcon, Calendar, FileText } from 'lucide-react';
import { formatDate, formatTime } from '../../utils/dateUtils';

const EventLogs = ({ eventLogs, isLoading }) => {
  if (isLoading) {
    return (
      <div className="bg-white border border-gray-200 rounded-lg p-4">
        <div className="animate-pulse space-y-4">
          <div className="h-5 w-32 bg-gray-200 rounded"></div>
          <div className="space-y-3">
            <div className="h-20 bg-gray-200 rounded"></div>
            <div className="h-20 bg-gray-200 rounded"></div>
          </div>
        </div>
      </div>
    );
  }

  if (!eventLogs || eventLogs.length === 0) {
    return null;
  }

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4">
      <h3 className="text-sm font-bold text-gray-900 mb-4">Event Timeline</h3>
      <div className="space-y-4">
        {eventLogs.map((log, index) => (
          <div key={log.id} className="relative pl-8 pb-4 border-l-2 border-gray-200 last:border-l-0 last:pb-0">
            {/* Timeline dot */}
            <div className={`absolute left-0 top-1 w-4 h-4 rounded-full border-2 border-white ${
              log.event_type === 'start' ? 'bg-green-500' : 'bg-red-500'
            }`} style={{ marginLeft: '-9px' }} />

            {/* Content */}
            <div className="space-y-2">
              <div className="flex items-center gap-2">
                {log.event_type === 'start' ? (
                  <Play className="w-4 h-4 text-green-600" />
                ) : (
                  <Square className="w-4 h-4 text-red-600" />
                )}
                <span className="text-sm font-semibold text-gray-900">
                  Event {log.event_type === 'start' ? 'Started' : 'Ended'}
                </span>
                <span className="text-xs text-gray-500">
                  {formatDate(log.event_time)} at {formatTime(log.event_time)}
                </span>
              </div>

              {log.notes && (
                <div className="flex items-start gap-2 bg-gray-50 rounded-lg p-3">
                  <FileText className="w-4 h-4 text-gray-400 mt-0.5 flex-shrink-0" />
                  <p className="text-sm text-gray-700">{log.notes}</p>
                </div>
              )}

              {log.screenshots && log.screenshots.length > 0 && (
                <div className="space-y-2">
                  <div className="flex items-center gap-2 text-xs text-gray-600">
                    <ImageIcon className="w-4 h-4" />
                    <span>{log.screenshots.length} screenshot{log.screenshots.length > 1 ? 's' : ''}</span>
                  </div>
                  <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
                    {log.screenshots.map((screenshot, idx) => (
                      <a
                        key={idx}
                        href={screenshot}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="relative group"
                      >
                        <img
                          src={screenshot}
                          alt={`Screenshot ${idx + 1}`}
                          className="w-full h-24 object-cover rounded-lg border border-gray-200 hover:border-gray-400 transition-colors"
                        />
                        <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-10 transition-opacity rounded-lg" />
                      </a>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EventLogs;

